var map = {
	"./basme/4.jpg": "1d34",
	"./cacealma/4.jpg": "6ce9",
	"./gewalt/4.jpg": "0c22",
	"./jurnal-tetelu/4.jpg": "1355",
	"./la-inceput/4.jpg": "3eea",
	"./nichita/4.jpg": "719d",
	"./oaianeagra/4.jpg": "3263",
	"./peei/4.jpg": "1243",
	"./scrisoare-tata/4.jpg": "86e7",
	"./scrisori-front/4.jpg": "9b9b",
	"./urletul/4.jpg": "ad42"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46e1";